import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { TReportRtmType } from 'partner360/models/report/TReportRtmType'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from './translations'

export interface ICockpitDocumentLinkContext {
  partnerId?: string
  offering: ProgramTypes
  fYear: number
  fQuarter: number
  rtm: TReportRtmType
}

interface ICockpitDocumentLinkConfig {
  id: string
  label: string
  buildHref: (context: ICockpitDocumentLinkContext) => string | null
}

const buildReportHref = (
  reportType: string,
  context: ICockpitDocumentLinkContext,
  includeQuarter = false
): string => {
  const quarter = includeQuarter ? `/quarter/${context.fQuarter}` : ''

  return `/page/jbp-reports/reportType/${reportType}/fYear/${context.fYear}${quarter}/rtm/${context.rtm}`
}

const LABELS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks.links

export const COCKPIT_DOCUMENT_LINKS: ICockpitDocumentLinkConfig[] = [
  {
    id: 'sob-trends',
    label: LABELS.sobTrends,
    buildHref: ({ partnerId, offering }) =>
      partnerId
        ? `/page/jbp-sob-trends/pid/${encodeURIComponent(partnerId)}/ptype/${encodeURIComponent(offering)}`
        : null,
  },
  {
    id: 'completeness-report',
    label: LABELS.completenessReport,
    buildHref: (context) => buildReportHref('completeness-report', context),
  },
  {
    id: 'sob-input',
    label: LABELS.sobInput,
    buildHref: (context) => buildReportHref('sob-tracking', context, true),
  },
  {
    id: 'sob-results',
    label: LABELS.sobResults,
    buildHref: (context) => buildReportHref('sob-analytics', context),
  },
  {
    id: 'financial-results',
    label: LABELS.financialResults,
    buildHref: (context) => buildReportHref('financial-analytics', context),
  },
  {
    id: 'key-initiatives',
    label: LABELS.keyInitiatives,
    buildHref: (context) => buildReportHref('key-initiatives', context),
  },
  {
    id: 'general-reports',
    label: LABELS.generalReports,
    buildHref: () => '/page/jbp-reports/reportType/general-report',
  },
]
